import { gql } from '@apollo/client';

export const ASSIGN_USER = gql`
mutation assignUser($input: UserInput!) {
  assignUser(input: $input) {
    user {
      id
      firstName
      lastName
      position
      roles {
        id
        name
        type
      }
      status
    }
  }
}
`;
